
import { Vue, Component, Ref, Watch } from 'vue-property-decorator';
import GoodsModal from './components/GoodsModal.vue';
import SalesPlanModal from './components/SalesPlanModal.vue';
import lazyInject from '@/di';
import SupplyService from '@/services/supply.service';
import { CCommodityList } from '@/models/supply.model';

enum StatusEnum {
  ON_SHELF = '上架',
  OFF_SHELF = '下架',
}
@Component({
  components: {
    GoodsModal,
    SalesPlanModal,
  },
})
export default class GoodsList extends Vue {
  form: any = {
    commodity_code: '',
    name: '',
    status: undefined,
  };

  StatusEnum = StatusEnum;

  @lazyInject(SupplyService)
  supplyService!: SupplyService;

  pagination: any = {
    current: 1,
    pageSize: 10,
    total: 0,
    showSizeChanger: true,
    pageSizeOptions: this.$store.state.pageSize.pageSize,
    showTotal: () => `共${this.pagination.total}条`,
    onChange: this.paginationChange,
    onShowSizeChange: this.onShowSizeChange,
  };

  columns = [
    {
      title: '物料编码',
      dataIndex: 'commodityCode',
      key: 'commodityCode',
      align: 'center',
    },
    {
      title: '一级类目',
      dataIndex: 'category',
      key: 'category',
      align: 'center',
      customRender: () => {
        return '机油';
      },
    },
    {
      title: '二级类目',
      key: 'subCategory',
      align: 'center',
      dataIndex: 'subCategory',
      customRender: () => {
        return '机油';
      },
    },
    {
      title: '产品名称',
      dataIndex: 'name',
      key: 'name',
      align: 'center',
      width: 220,
    },
    {
      title: '状态',
      key: 'status',
      align: 'center',
      dataIndex: 'status',
    },
    {
      title: '操作',
      dataIndex: 'action',
      key: 'action',
      align: 'center',
      scopedSlots: { customRender: 'action' },
    },
  ];
  data = [];

  @Watch('$route')
  onRouteChange() {
    const { commodity_code, name, status, page, pageSize } = this.$route.query;
    const params: any = {
      page: page || 1,
      pageSize: pageSize || 10,
    };
    if (commodity_code) {
      params.commodity_code = commodity_code;
      this.form.commodity_code = commodity_code;
    }
    if (name) {
      params.name = name;
      this.form.name = name;
    }
    if (status !== undefined && status !== '') {
      params.status = status;
      this.form.status = +status;
    }
    this.getList(params);
  }

  async getList(params: any) {
    const res = await this.supplyService.getCommodityList(params);
    // console.log(res);
    if (res) {
      this.data = res.list.map((item: any) => CCommodityList.from(item));
      this.pagination.total = +res.total;
      this.pagination.current = res.page;
      this.pagination.pageSize = res.pageSize;
    }
  }

  editGoods(record: any) {
    this.goodsModal.open(record);
  }

  @Ref('goodsModal')
  goodsModal!: GoodsModal;

  addGoods() {
    this.goodsModal.open();
  }

  refresh() {
    // TODO: 调用商品列表接口刷新数据
    this.onRouteChange();
  }

  async updateStatus(record: any) {
    const res = await this.supplyService.postCommodityUpdateStatus({
      id: record.id,
      status: record.status === StatusEnum.ON_SHELF ? 0 : 1,
    });
    if (res) {
      this.$message.success('操作成功');
      this.refresh();
    }
  }

  salesPlan(record: any) {
    this.salesPlanModal.open(record);
  }

  @Ref('salesPlanModal')
  salesPlanModal!: SalesPlanModal;

  search() {
    this.pagination.current = 1;
    this.getQueryParams();
  }

  resetQuery() {
    this.form = {
      commodity_code: '',
      name: '',
      status: undefined,
    };
    this.pagination.current = 1;
    this.getQueryParams();
  }

  paginationChange(page: number, pageSize: number) {
    this.pagination.current = page;
    this.pagination.pageSize = pageSize;
    this.getQueryParams();
  }

  onShowSizeChange(current: number, pageSize: number) {
    this.pagination.current = 1;
    this.pagination.pageSize = pageSize;
    this.getQueryParams();
  }
  getQueryParams() {
    const { commodity_code, name, status } = this.form;
    const { current, pageSize } = this.pagination;
    const query: any = { page: current, pageSize };
    if (commodity_code) {
      query.commodity_code = commodity_code;
    }
    if (name) {
      query.name = name;
    }
    if (status !== undefined && status !== '') {
      query.status = status;
    }
    query.timestamp = Math.round(Date.now() / 1000);
    this.$router.push({ query });
  }

  mounted() {
    this.onRouteChange();
  }
}
